import React from "react";

import Preferences from "./Preferences";
import { apiGet, apiPost } from "../common/API";

class PreferencesController extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: 'list',
    };
  }

  componentDidMount() {
  }

  backToMenu(e) {
    e.preventDefault();
    this.props.backToMenu();
  }

  render() {
    const {mode} = this.state;
    switch (mode) {
      case '':
        return <Preferences {...this.props} handleBack={e => this.backToMenu(e)}/>

    }
    return <Preferences {...this.props} handleBack={e => this.backToMenu(e)} />
  }
}

export default PreferencesController;
